import { defineMessages } from 'react-intl';

export const jsmPortalPlaygroundRovoChatMessages = defineMessages({
	chatLabel: {
		id: 'JsmPortalPlayground.rovoChat.chatLabel',
		defaultMessage: 'Beaconstone Support chat',
	},
	chatName: {
		id: 'JsmPortalPlayground.rovoChat.chatName',
		defaultMessage: 'Beaconstone Support',
	},
	showHistory: {
		id: 'JsmPortalPlayground.rovoChat.showHistory',
		defaultMessage: 'Show chat history',
	},
	newChat: {
		id: 'JsmPortalPlayground.rovoChat.newChat',
		defaultMessage: 'New chat',
	},
	saveChat: {
		id: 'JsmPortalPlayground.rovoChat.saveChat',
		defaultMessage: 'Save chat',
	},
	moreActions: {
		id: 'JsmPortalPlayground.rovoChat.moreActions',
		defaultMessage: 'More chat actions',
	},
	closeChat: {
		id: 'JsmPortalPlayground.rovoChat.closeChat',
		defaultMessage: 'Close chat',
	},
	visitorQuestion: {
		id: 'JsmPortalPlayground.rovoChat.visitorQuestion',
		defaultMessage: 'How do I setup VPN access for remote work?',
	},
	thinking: {
		id: 'JsmPortalPlayground.rovoChat.thinking',
		defaultMessage: 'Rovo is thinking',
	},
	answerIntro: {
		id: 'JsmPortalPlayground.rovoChat.answerIntro',
		defaultMessage: "Here's step-by-step instructions on how to setup Beaconstone VPN:",
	},
	answerStep1Heading: {
		id: 'JsmPortalPlayground.rovoChat.answerStep1Heading',
		defaultMessage: 'Step 1: Install VPN client',
	},
	answerStep1Before: {
		id: 'JsmPortalPlayground.rovoChat.answerStep1Before',
		defaultMessage: 'Download the approved VPN client from',
	},
	answerStep1Link: {
		id: 'JsmPortalPlayground.rovoChat.answerStep1Link',
		defaultMessage: 'VPN installer',
	},
	answerStep1After: {
		id: 'JsmPortalPlayground.rovoChat.answerStep1After',
		defaultMessage: 'then open the installer and follow the instructions',
	},
	answerStep2Heading: {
		id: 'JsmPortalPlayground.rovoChat.answerStep2Heading',
		defaultMessage: 'Step 2: Sign in with SSO',
	},
	answerStep2Bullet1: {
		id: 'JsmPortalPlayground.rovoChat.answerStep2Bullet1',
		defaultMessage: 'Open the VPN application and select "Sign-in"',
	},
	answerStep2Bullet2: {
		id: 'JsmPortalPlayground.rovoChat.answerStep2Bullet2',
		defaultMessage: 'Complete MFA verification with official credentials',
	},
	answerStep3Heading: {
		id: 'JsmPortalPlayground.rovoChat.answerStep3Heading',
		defaultMessage: 'Step 3: Connect',
	},
	answerStep3Bullet1: {
		id: 'JsmPortalPlayground.rovoChat.answerStep3Bullet1',
		defaultMessage: 'Select profile: Beaconstone-GB and click connect',
	},
	answerStep3Bullet2: {
		id: 'JsmPortalPlayground.rovoChat.answerStep3Bullet2',
		defaultMessage: 'Complete MFA verification with official credentials',
	},
	answerOutro: {
		id: 'JsmPortalPlayground.rovoChat.answerOutro',
		defaultMessage: 'You should now have secure remote access.',
	},
	sources: {
		id: 'JsmPortalPlayground.rovoChat.sources',
		defaultMessage: '2 Sources',
	},
	goodAnswer: {
		id: 'JsmPortalPlayground.rovoChat.goodAnswer',
		defaultMessage: 'Good answer',
	},
	badAnswer: {
		id: 'JsmPortalPlayground.rovoChat.badAnswer',
		defaultMessage: 'Bad answer',
	},
	giveFeedback: {
		id: 'JsmPortalPlayground.rovoChat.giveFeedback',
		defaultMessage: 'Give feedback',
	},
	askFollowUp: {
		id: 'JsmPortalPlayground.rovoChat.askFollowUp',
		defaultMessage: 'Ask a follow-up',
	},
	addContext: {
		id: 'JsmPortalPlayground.rovoChat.addContext',
		defaultMessage: 'Add context',
	},
	moreApps: {
		id: 'JsmPortalPlayground.rovoChat.moreApps',
		defaultMessage: '×5',
	},
	agentPicker: {
		id: 'JsmPortalPlayground.rovoChat.agentPicker',
		defaultMessage: 'Auto',
	},
	dictate: {
		id: 'JsmPortalPlayground.rovoChat.dictate',
		defaultMessage: 'Dictate',
	},
	disclosure: {
		id: 'JsmPortalPlayground.rovoChat.disclosure',
		defaultMessage: 'Uses AI. Verify results.',
	},
});
